import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a5f7073a&"
import script from "./App.js?vue&type=script&lang=js&"
export * from "./App.js?vue&type=script&lang=js&"
import style0 from "./App.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports